import { useActiveConfigValues } from '../../../../hooks/useActiveConfigValues';
import {
    BasePickerProps,
    useUpdatePropInConfiguration,
} from '../../../../utils/pickerHelper';

export function SingleLinePicker({ propName }: BasePickerProps) {
    const updateProperty = useUpdatePropInConfiguration(propName);
    const { activeWidget } = useActiveConfigValues();
    return (
        <input
            className="block w-full rounded-lg border p-2.5"
            id={propName}
            placeholder="Enter text here..."
            value={(activeWidget?.widgetData[propName] as string) ?? ''}
            onChange={(event) => {
                const newValue = event.target.value;
                updateProperty(newValue);
            }}
        />
    );
}
